import { render, staticRenderFns } from "./UNavbar.vue?vue&type=template&id=0ec0d569&"
import script from "./UNavbar.vue?vue&type=script&lang=js&"
export * from "./UNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports